import { render, staticRenderFns } from "./CustomerTab.vue?vue&type=template&id=26af0f98&scoped=true&"
import script from "./CustomerTab.vue?vue&type=script&lang=js&"
export * from "./CustomerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af0f98",
  null
  
)

export default component.exports